import { User } from '../../types';

const NullUser: User = {
  active: false,
  email: '',
  firstName: '',
  insertion: '',
  lastName: '',
  roles: [],
  permissions: [],
};

export default NullUser;
